import l from '../../../../lang';
import IntegrationCard from '../integration-card';
import { ReactComponent as FenicioIcon } from '../../../../assets/icons/integrations/fenicio.svg';
import { usePaymentIntegration } from '../../../../store/payment-integration';
import { DetailsOpened } from '../../../../store/payment-integration/interfaces';

export default () => {
  const { setDetailsOpened } = usePaymentIntegration();

  return (
    <IntegrationCard
      title={l('paymentIntegration.fenicio.title')}
      icon={<FenicioIcon />}
      color="light-blue"
      onDetails={() => {
        setDetailsOpened(DetailsOpened.FENICIO);
      }}
      detailsText={l('paymentIntegration.card.integration.voting.link')}
    />
  );
};
